










































import {Component, Prop, Vue} from 'vue-property-decorator'
import DesignMenuNavi from '@/pages/DesignPage/DesignMenuNavi.vue'
import DesignSettingBar from '@/pages/DesignPage/DesignSettingBar.vue'
import Preview from "@/components/Preview.vue";
import MenusStore from "@/store/modules/MenusStore";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";
import CategoriesStore from "@/_common/api/store/modules/CategoriesStore";
import ThemeCategoryVariablesStore from "@/store/modules/ThemeCategoryVariablesStore";
import ThemeItemVariablesStore from "@/store/modules/ThemeItemVariablesStore";
import CategoryItemsStore from "@/_common/api/store/modules/CategoryItemsStore";
import ItemsStore from "@/_common/api/store/modules/ItemsStore";
import SelectionsStore from "@/_common/api/store/modules/SelectionsStore";
import CondimentGroupsStore from "@/_common/api/store/modules/CondimentGroupsStore";
import DeliousItemsStore from "@/_common/api/store/modules/DeliousItemsStore";
import ThemesStore from "@/store/modules/ThemesStore";
import DialogButtons from '@/components/Dialog/parts/DialogButtons.vue'
import HeaderBar from '@/components/HeaderBar.vue';
import Navigator from '@/components/Navigator.vue';
import StoresStore from '@/store/modules/StoresStore';
import GenerationsStore from '@/store/modules/GenerationsStore';

@Component({
    components: {
        HeaderBar,
        Navigator,
        DesignMenuNavi,
        DesignSettingBar,
        Preview,
        DialogButtons
    },
})
export default class DesignPage extends Vue {
    private createdFlg:boolean = false;

    async created() {
        const menuId: number = Number(this.$route.params.menuId);

        await MenusStore.init();

        const storeId: number = MenusStore.menuById[menuId].store_ids ? Number(MenusStore.menuById[menuId].store_ids[0]) : Number(StoresStore.all[0].code);
        await DeliousItemsStore.init({storeId: storeId, periodId: GenerationsStore.selected.period_no});

        await CategoriesStore.init(menuId);
        await CategoryItemsStore.init(menuId);

        const themeId: number = MenusStore.menuById[menuId].theme_id;
        ThemesStore.selectTheme(themeId)
        ThemeVariableStore.init({themeId: themeId, menuId: menuId});
        ThemeCategoryVariablesStore.init({themeId: themeId, menuId: menuId});
        ThemeItemVariablesStore.init(themeId);
        this.createdFlg = true;
    }

    get menu(): CMS.Menu {
        return MenusStore.menuById[Number(this.$route.params.menuId)] || {};
    }

    get categories() {
        return CategoriesStore.all;
    }

    get categoryItems() {
        return CategoryItemsStore.all;
    }

    get cmsItems() {
        return ItemsStore.all;
    }

    get selections() {
        return SelectionsStore.all;
    }

    get condimentGroups() {
        return CondimentGroupsStore.all;
    }

    get themeVariable() {
        return ThemeVariableStore.all;
    }

    get themeCategoryVariables() {
        return ThemeCategoryVariablesStore.all;
    }

    get themeItemVariables() {
        return ThemeItemVariablesStore.all;
    }

    get deliousItems() {
        return DeliousItemsStore.all;
    }

    get pagePath() {
        const pageName = this.$route.params.pageName;
        const page: CMS.Page = ThemesStore.selectedThemePageByName[pageName];
        return page ? page.preview_path : "root";
    }

    get dirty(): boolean {
        return ThemeVariableStore.dirty || ThemeCategoryVariablesStore.dirty
    }

    private onClickCancel() {
        const enableLeave: boolean = this.dirty
            ? window.confirm("メニューのトップに遷移します。\n保存していない変更が失われますがよろしいですか？")
            : true;

        if (enableLeave) {
            ThemeVariableStore.cancelEdit();
            ThemeCategoryVariablesStore.cancelEdit();
            this.$router.push({name: 'menu_top', params: {itemId: Number(this.$route.params.menuId).toString()}}, () => {});
        }

        //todo 仮置き editor-header内のタブで遷移時のことを考える

    }

    private onClickUpdate() {
        ThemeVariableStore.applyEdit();
        ThemeCategoryVariablesStore.applyEdit();
    }
}

